import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from 'src/app/config/environments/environment'

import { Gate } from '../../models/interfaces/arrival/gate.interface'
import { PageDto } from '../../models/dto/arrival/page.dto'
import { GatesMonitorDto } from '../../models/dto/arrival/gates-monitor.dto'
import { GateArrivalsFilterDto } from '../../models/dto/arrival/gate-arrivals-filter.dto'

import { buildParams } from '../../factory/arrivals-filter.factory'
import { GateFilterDto } from '../../models/dto/arrival/gate-filter.dto'

@Injectable()
export class GateService {

  private readonly gatesPath = 'gates'
  private readonly arrivalsPath = 'arrivals'

  constructor(private http: HttpClient) { }

  getAll(filter?: GateFilterDto): Observable<Gate[]> {
    const url = `${environment.api.baseUrl}/${this.gatesPath}`
    const params = this.buildHttpParams(filter)
    const gates = this.http.get<Gate[]>(
      url, { params:  params })
      .pipe((response) => response
    )
    return gates
  }

  create(gate: Gate): Observable<Gate> {
    return this.http.post<Gate>(
      `${environment.api.baseUrl}/${this.gatesPath}`, gate
    )
  }

  getById(id: string): Observable<Gate> {
    return this.http.get<Gate>(
      `${environment.api.baseUrl}/${this.gatesPath}/${id}`
    )
  }

  update(gate: Gate): Observable<Gate> {
    return this.http.put<Gate>(
      `${environment.api.baseUrl}/${this.gatesPath}/${gate.id}`, gate
    )
  }

  delete(id: string): Observable<any>{
    return this.http.delete(
      `${environment.api.baseUrl}/${this.gatesPath}/${id}`
    )
  }

  getArrivalsByIdAndFilter(id: string, filter: GateArrivalsFilterDto): Observable<any> {
    const params: HttpParams = buildParams(filter)
    const url = `${environment.api.baseUrl}/${this.gatesPath}/${id}/${this.arrivalsPath}`
    return this.http.get<PageDto<GatesMonitorDto>>(url,  { params } )
  }

  private buildHttpParams(filter?: GateFilterDto): HttpParams {
    let params = new HttpParams()

    if(filter?.idsClassrooms && filter?.idsClassrooms.length > 0) {
      const ids = filter.idsClassrooms.join(',')

      params = params.set('idsClassrooms', ids)
    }

    if(filter?.idsResponsables && filter?.idsResponsables.length > 0) {
      const ids = filter.idsResponsables.join(',')

      params = params.set('idsResponsables', ids)
    }

    if(filter?.idSchool && filter?.idSchool != '') {
      params = params.set('idSchool', filter?.idSchool)
    }

    return params
  }
}
